import { DeleteAndMustMoveFreeFieldProfile } from "components/modals/DeleteAndMustMoveItems";
import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import React from "react";

interface Props {
  optionsPanelData: server.dto.OptionsPanelDataV2
  listUrl: string
  freeFieldProfileId: number
  environment: server.dto.Environments
}

const FreeFieldProfileOptionsPanel = (props: Props) => {
  const [isDeleting, setIsDeleting] = React.useState<boolean>(false);

  const isNewProfile = props.freeFieldProfileId === 0;

  return <>
    <GeneralOptionsPanel
      data={props.optionsPanelData}
      links={[{
        href: props.listUrl,
        text: RESX.Buttons.ListView,
        visible: true
      }, {
        onClick: () => { setIsDeleting(true); },
        text: RESX.Buttons.btnDelete,
        visible: !isNewProfile,
      }]}
    />
    <DeleteAndMustMoveFreeFieldProfile
      freeFieldProfileId={props.freeFieldProfileId}
      afterDeleteRedirectUrl={props.listUrl}
      environment={props.environment}
      isOpen={isDeleting}
      onClose={() => { setIsDeleting(false); }}
    />
  </>
};

export default FreeFieldProfileOptionsPanel;
